import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import { submissionsApi } from '../../api/Submission';
import { createRoot } from 'react-dom/client';
import { useCollection } from '@cloudscape-design/collection-hooks';
import { createColumnDefinitions } from './table-select-filter-config';
import { Preferences } from '../commons/table-config';
import {
  Button,
  ButtonDropdown,
  Input,
  FormField,
  Pagination,
  SpaceBetween,
  Select,
  Table,
  Modal,
  Box,
  Link
} from '@cloudscape-design/components';
import { Navigation, Breadcrumbs, ToolsContent } from './table-select-filter-components';
import '../../styles/table-select.scss';
import { getTextFilterCounterText, getHeaderCounterText, renderAriaLive } from '../../i18n-strings';
import { CustomAppLayout, Notifications, TableEmptyState, TableNoMatchState } from '../commons/common-components';
import { FullPageHeader } from '../commons';
import { useColumnWidths } from '../commons/use-column-widths';
import { useLocalStorage } from '../commons/use-local-storage';
import FrameworkModal from './StartApplicationModal'; 
import FrameworkDownloadModal from './DownloadFrameworkModal';
import { useBreadcrumbs } from '../../components/breadcrumbs/index';


const defaultEngine = { value: '0', label: 'Any Engine' };
const defaultClass = { value: '0', label: 'All' };


function matchesEngine(item, selectedEngine) {
  return selectedEngine === defaultEngine || item.engine === selectedEngine.label;
}

function matchesClass(item, selectedClass) {
  return selectedClass === defaultClass || item.class === selectedClass.label;
}

export function TableSelectFilter({ loadHelpPanelContent }) {
    const { setActiveBreadcrumb } = useBreadcrumbs();
    useEffect(() => {
      setActiveBreadcrumb(
        { text: 'Annual Submissions', href: '/my-submissions', index: 1 },
        1
      );
    }, []);
  
  
  
    
  const [DATA, setDATA] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const refreshData = async () => {
    setLoading(true);
    try {
      const data = await submissionsApi.getAll();
      setDATA(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Create column definitions with refresh callback
  const COLUMN_DEFINITIONS = createColumnDefinitions(refreshData);
  const [columnDefinitions, saveWidths] = useColumnWidths('React-TableSelectFilter-Widths', COLUMN_DEFINITIONS);
  const [engine, setEngine] = useState(defaultEngine);
  const [selectEngineOptions, setSelectEngineOptions] = useState([]);
  const [selectClassOptions, setSelectClassOptions] = useState([]);
  
  const [visible, setVisible] = React.useState(false);
  const [visible2, setVisible2] = React.useState(false);
  const [
    selectedOption,
    setSelectedOption
  ] = React.useState({ label: "Option 1", value: "1" });

  const [instanceClass, setInstanceClass] = useState(defaultClass);
  const [preferences, setPreferences] = useLocalStorage('React-TableSelectFilter-Preferences', {
    pageSize: 30,
    contentDisplay: [
      { id: 'id', visible: true },
      { id: 'title', visible: true },
      { id: 'submissionDate', visible: true },
      { id: 'status', visible: true },
      { id: 'notes', visible: true },
      { id: 'comments', visible: true },
      { id: 'reviewer', visible: true },
    ],
    wrapLines: false,
    stripedRows: false,
    contentDensity: 'comfortable',
    custom: 'table',
  });

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <Table
      enableKeyboardNavigation={true}
      columnDefinitions={columnDefinitions}
      items={DATA} 
      loading={loading}
      loadingText="Loading applications..."
      variant="full-page"
      stickyHeader={true}
      resizableColumns={true}
      onColumnWidthsChange={saveWidths}
      wrapLines={preferences.wrapLines}
      stripedRows={preferences.stripedRows}
      contentDensity={preferences.contentDensity}
      stickyColumns={preferences.stickyColumns}
      ariaLabels={{
        itemSelectionLabel: (data, row) => `Select DB instance ${row.id}`,
        allItemsSelectionLabel: () => 'Select all DB instances',
        selectionGroupLabel: 'Instances selection',
      }}
      empty={
        <Box
          margin={{ vertical: "xs" }}
          textAlign="center"
          color="inherit"
        >
          <SpaceBetween size="m">
            <b>No Applications</b>
          </SpaceBetween>
        </Box>
      }
      renderAriaLive={renderAriaLive}
      header={
        <FullPageHeader
          title="Institution Applications"
          actions={
            <SpaceBetween size="xs" direction="horizontal">
              <Button variant="primary" onClick={()=> setVisible2(true)}
              >Download Framework</Button>
              <Button variant="primary" onClick={()=> setVisible(true)}
              >New Submission</Button>

            <FrameworkDownloadModal 
              visible={visible2} 
              setVisible={setVisible2} 
            />

            <FrameworkModal 
            visible={visible} 
            setVisible={setVisible}
            onSubmit={(framework) => {
              console.log('Selected framework:', framework);
            }}
          />
            </SpaceBetween>
          }
          onInfoLinkClick={loadHelpPanelContent}
        />
      }
      filter={
        <div className="input-container">
        </div>
      }
    />
  );
}
